import React from 'react';
import { Badge } from '@/components/ui/badge';

const CONFIG: Record<string, { label: string; variant: 'default' | 'secondary' | 'destructive' | 'outline' }> = {
  auto: { label: 'Auto', variant: 'default' },
  research: { label: 'Research', variant: 'secondary' },
  expert_review: { label: 'Expert', variant: 'destructive' },
};

export function AuthorityBadge({ action }: { action: string }) {
  const config = CONFIG[action] || { label: action, variant: 'outline' as const };
  return <Badge variant={config.variant}>{config.label}</Badge>;
}
